import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { ArrowLeft, Save } from "react-feather";

import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";

import { FormProvider, useForm } from "react-hook-form";
import { add, format } from "date-fns";
import { yupResolver } from "@hookform/resolvers/yup";

import Error404 from "MainPages/ErrorPages/error404";
import { all_routes } from "Router/all_routes";
import { Link, useNavigate } from "react-router-dom";
import {
  dormitoryValidationSchema,
  locationValidation,
} from "core/Operations/ValidationSchema/MasterValidationSchema";
import DormitoryForm from "Components/Form/DormitoryForm";
import { useInsertDormitoryMutation } from "AppQuries/master/dormitory";
import { toast } from "core/Operations/toast";
import { BackIcon } from "Components/UI/Icon/Icons";
const AddDormitory = () => {
  const userData = useSelector(loggedInUser);
  const {
    mutate: addDormitory,
    isPending,
    isError,
    error,
  } = useInsertDormitoryMutation();
  const methods = useForm({
    defaultValues: {
      companyCode: userData.companyCode,
      dormitoryCode: 0,
      dormitoryName: "",
      inchargeName: "",
      inchargeNumber: "",
      address: "",
      postalcode: "",
      attachment: "",
      createUser: userData.userName,
      createDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      modifyUser: userData.userName,
      modifyDate: `${format(new Date(), "yyyy-MM-dd")}T${format(
        new Date(),
        "HH:mm:ss.SSS"
      )}Z`,
      isActive: true,
    },
    resolver: yupResolver(dormitoryValidationSchema),
    mode: "onChange",
  });

  const navigate = useNavigate();

  const {
    handleSubmit,
    formState: { errors },
  } = methods;

  console.log(errors);
  const onSubmit = (payload) => {
    console.log(payload);
    addDormitory(payload, {
      onSuccess: (data) => {
        console.log(data);
        if (data === true) {
          toast.success("Dormitory Added Successfully.");

          setTimeout(() => {
            navigate(`${all_routes.master}${all_routes.dormitory}`);
          }, 1000);
        } else {
          toast.warning(data?.[0]?.errorMessage || "Something went wrong.");
        }
      },
      onError: (error) => {
        toast.error(error.message || "Something went wrong.");
      },
    });
  };
  if (isError) return <Error404 error={error} />;
  return (
    <div>
      <div className="page-wrapper">
        <FormProvider {...methods}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="content">
              <div className="page-header">
                <div className="add-item d-flex">
                  <div className="page-title">
                    <h4>Add New Dormitory</h4>
                    <h6>Add your new dormitory details </h6>
                  </div>
                </div>
                

                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Save Dormitory</Tooltip>
                    }
                  >
                    <button type="submit" className="btn btn-added">
                      <Save className="me-2" />
                      Save
                    </button>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Back</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.master}${all_routes.dormitory}`}
                      className="btn btn-secondary"
                    >
                      <BackIcon className="me-2" />
                      Back
                    </Link>
                  </OverlayTrigger>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div className="card border-0">
                    <div className="card-header">
                      <h4 className="card-title">Add Dormitory</h4>
                    </div>
                    <div className="card-body">
                      <DormitoryForm />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </FormProvider>
      </div>
    </div>
  );
};

export default AddDormitory;
